import { InputLabel } from "@mui/material";
import InputBox from "./InputBox";
import { PField } from "./NestedField";
import { requiredValidator } from "./validator";
import { Editor } from '@tinymce/tinymce-react';

const styles = {


    labelForm: {
        fontSize: 12,
        paddingBottom: 3,
    }
};
export default function FormatedTextInput({
    name,
    label,
    initialValue,
    required,
    helperText,
    sx,
    ...props
}) {
    return (
        <InputBox sx={{ justifyContent: 'center', ...sx }}>
            <PField
                name={name}
                initialValue={initialValue}
                validate={required ? requiredValidator : null}
            >
                {(fieldProps) => {
                    // const hasError = fieldHasError(fieldProps.meta);
                    const handleEditorChange = (content, editor) => {
                        fieldProps.input.onChange(content);
                    }
                    return (
                        <div style={{ paddingBottom: 10 }}>
                            {label && <InputLabel
                                style={styles.labelForm}
                            >{label}</InputLabel>}
                            <Editor
                                value={fieldProps.input.value}

                                apiKey="q2yj9emgr387nl1n4859h3mnw64hqct6bejt4f4nabjvghuu"
                                init={{
                                    // placeholder,
                                    height: 700,
                                    // inline: inlineUsar,
                                    language: 'pt_BR',
                                    menubar: 'edit insert view format table',
                                    plugins: 'searchreplace autolink directionality visualblocks visualchars fullscreen image link media table charmap nonbreaking anchor toc insertdatetime advlist lists charmap quickbars emoticons',
                                    toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat |  charmap emoticons | fullscreen | insertfile image media link anchor | ltr rtl',
                                    // menubar: false,
                                    // plugins: [
                                    //     'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                    //     'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                    //     'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                                    // ],
                                    // toolbar: 'undo redo | blocks | ' +
                                    //     'bold italic forecolor | alignleft aligncenter ' +
                                    //     'alignright alignjustify | bullist numlist outdent indent | ' +
                                    //     '| insertfile image media link anchor |' +
                                    //     'removeformat | help',
                                }}

                                onEditorChange={handleEditorChange}
                                {...props}
                            />
                        </div>
                    );
                }}
            </PField>
        </InputBox>
    );
}